module.exports = __webpack_public_path__ + "img/newsletter-banner.99219c69.jpg";